// 公共方法
import { Toast } from 'vant'

var showToast = function (msg) {
  Toast({
    message: msg,
    duration: 1500
  })
}

var showLoading = function (msg) {
  Toast.loading({
    mask: true,
    forbidClick: true,
    duration: 0,
    message: msg
  })
}

var hideLoading = function () {
  Toast.clear()
}

var showSuccess = function (msg) {
  Toast.success({
    message: msg,
    duration: 2000
  })
}

var showWarning = function (msg) {
  Toast.fail({
    message: msg,
    duration: 2000
  })
}

/**
 * 本地存储数据 storage
 * sessionStorage  临时存储，在关闭窗口或标签页之后将会删除这些数据
 * localStorage    没有过期时间，直至手动删除
 */
var storage = {
  sessionSetItem: function (key, value) {
    sessionStorage.setItem(key, JSON.stringify(value))
  },
  sessionGetItem: function (key) {
    return JSON.parse(sessionStorage.getItem(key))
  },
  sessionRemoveItem: function (key) {
    sessionStorage.removeItem(key)
  },

  /* 永久存储 */
  localSetItem: function (key, value) {
    localStorage.setItem(key, JSON.stringify(value))
  },
  localGetItem: function (key) {
    return JSON.parse(localStorage.getItem(key))
  },
  localRemoveItem: function (key) {
    localStorage.removeItem(key)
  }
}

var interval
function countDown(func) {
  interval = window.setInterval(function () {
    func()
  }, 1000)
}
var clearCountDown = function () {
  clearInterval(interval)
  // interval = null
  console.log('清除成功', '')
}
 
export {
  showToast,
  showLoading,
  hideLoading,
  showSuccess,
  showWarning,
  storage,
  interval,
  countDown,
  clearCountDown
}



//////////////////
// WEBPACK FOOTER
// ./static/turnoverCabinet/js/utility.js
// module id = 7w1Z
// module chunks = 1